var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('details-sheet',_vm._b({attrs:{"item":_vm.subscription,"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.customer",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.name))]),(item.person)?_c('v-btn',{staticClass:"float-right",attrs:{"small":"","icon":"","to":_vm.to}},[_c('v-icon',[_vm._v("mdi-eye")])],1):_vm._e()]}},{key:"item.address",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.address)+"\n  ")]}}])},'details-sheet',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }